import { render, staticRenderFns } from "./OldShopOA.vue?vue&type=template&id=0362f85e&"
import script from "./OldShopOA.vue?vue&type=script&lang=js&"
export * from "./OldShopOA.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports